import React from "react";
import Center from "./Center";
import { TextBlock } from "./Text";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import { SpacingHeight } from "./Spacing";
import { IconCircleFilledIcon } from "./Icon";
import AppTheme from "../../../service/app_config/AppTheme";

const NoData = () => {
  return (
    <Center className="py-5">
      <div className="text-center">
        <IconCircleFilledIcon
          name="no_data_2"
          size={102}
          color={AppTheme.white}
        />
        <SpacingHeight value={20} />
        <TextBlock fontName="bold" textColor="theme-label" fontSize="20_21">
          {AppTranslation.text("no_results_found")}
        </TextBlock>
      </div>
    </Center>
  );
};

export default NoData;
